import { setCookie } from '../../helpers/cookies';

const setLicenseRequest = () => {
    return { type: 'SET_LICENSE_REQUEST' };
};

const setLicenseSuccess = id => {
    return { type: 'SET_LICENSE_SUCCESS', id };
};

const setLicenseFailure = error => {
    return {
        type: 'SET_LICENSE_FAILURE',
        error
    };
};

const setLicense = id => async (dispatch, getState) => {
    try {
        dispatch(setLicenseRequest());
        dispatch(setLicenseSuccess(id));
        const activeLicense = getState().license.active;
        const { expireDay } = getState().auth;

        setCookie('activeLicense', activeLicense, expireDay);
    } catch (error) {
        dispatch(setLicenseFailure(error));
    }
};

export { setLicenseRequest, setLicenseSuccess, setLicenseFailure, setLicense };
